import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex, textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        display: 'flex',
        width: '100%',
        height: '100%',
        minWidth: 0,
        // Must be able to shrink below content height so the inner body owns the
        // scroll on tablet/phone too (where this becomes a column flex item).
        minHeight: 0,
        overflow: 'hidden',
        [theme.down('tablet')]: {
            flexDirection: 'column',
        },
    },

    body: {
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing(6)}`,
        paddingTop: theme.spacing(3),
        width: 'auto',
        minWidth: 0,
        flex: 1,
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        [theme.down('tablet')]: {
            width: '100%',
            padding: `${theme.spacing(4)} ${0} ${0}`,
            paddingTop: theme.spacing(2),
        },
    },

    tabletSidebarToggleRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: theme.spacing(2),
        flexWrap: 'nowrap',
        marginBottom: theme.spacing(4),
        [theme.down('tablet')]: {
            alignItems: 'center',
            gap: theme.spacing(1),
            overflowX: 'auto',
        },
    },

    tabletSidebarToggle: {
        minHeight: 44,
        flex: '0 0 auto',
        borderRadius: 22,
        [theme.down('tablet')]: {
            minWidth: 0,
            padding: `0 ${theme.spacing(2)}`,
            fontSize: 14,
        },
    },

    tabletBackButton: {
        minHeight: 44,
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: `0 ${theme.spacing(2.5)}`,
        borderRadius: 22,
        flex: '0 0 auto',
        color: theme.colors.violet_primary,
        background: theme.colors.transp_violet,
        [theme.down('tablet')]: {
            minWidth: 0,
            padding: `0 ${theme.spacing(1.75)}`,
            fontSize: 14,
        },
    },

    tabletBackButtonIcon: {
        width: 18,
        height: 18,
        display: 'block',
        filter: 'brightness(0) saturate(100%) invert(18%) sepia(33%) saturate(1291%) hue-rotate(224deg) brightness(92%) contrast(90%)',
    },

    header: {
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        display: 'flex',
        justifyContent: 'space-between',
        height: '10%',
        alignContent: 'center',
        alignItems: 'center',
    },

    contentTitle:{
        color: theme.colors.black,
        fontFamily: theme.font.primary,
        fontSize: '20px',
        marginLeft: '10px',
    },

    filters: {
        display: 'flex',
        alignItems: 'center',
    },

    filterIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
    },

    searchWrapper: {
        width: '100%',
        maxWidth: 312,
        [theme.down('mobile')]: {
            maxWidth: 'none',
        },
        marginRight: theme.spacing(4),
    },

    ellipsis: {
        ...textOverflowDots(),
    },

    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        minHeight: 44,
        minWidth: 44,
        ...flex('row', 'center', 'center'),

        '&:disabled': {
            opacity: 0.3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },

}));
